import PropTypes from 'prop-types'
import { ICON_ORIGINAL_GRAY } from 'constants/colors'

const Tel = ({ color = ICON_ORIGINAL_GRAY, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 15" {...props}>
    <path
      d="M0 4.6c0-.8.1-1.5.5-2.2.2-.4.4-.7.7-1C1.6 1 2 .6 2.4.3c.5-.4 1-.3 1.4.1.5.5.8 1.1 1.2 1.6.2.4.4.7.5 1.1.2.7-.1 1.2-.6 1.6-.3.3-.6.5-.9.8-.4.3-.4.7-.3 1.2.1.6.5 1.1.8 1.6.5.7 1 1.3 1.6 1.8.4.4.9.8 1.5 1 .5.2.9.1 1.3-.3.3-.3.6-.6.9-.8.5-.4 1-.4 1.6-.2.5.2.9.5 1.3.9.2.2.4.3.6.5.3.3.6.6.7 1.1.1.3 0 .6-.2.9-.5.5-1.1 1.1-1.8 1.4-.6.3-1.2.5-1.8.5-1 .1-1.9-.2-2.8-.6-.8-.4-1.6-.9-2.3-1.5-.4-.4-.8-.7-1.2-1.1-.7-.8-1.4-1.5-2-2.4-.4-.6-.7-1.1-1-1.8C.6 7 .3 6.3.2 5.5 0 5.2 0 4.9 0 4.6"
      fill={color}
    />
  </svg>
)

Tel.propTypes = {
  color: PropTypes.string,
}

export default Tel
